import { axios } from "@Root/API";

export const postRecoveryToken = reset_token => {
  return axios.post("password/check-reset-token", { reset_token });
};
